<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <v-icon class="page-icon" color="#2e384d" size=60>mdi-car-door</v-icon>
      <p class="desc">{{ $t('selectPartsPage.description') }}</p>
      <LabelTextField 
        ref="filter" 
        :label="$t('selectPartsPage.searchLabel')" 
        @change="filter"
      ></LabelTextField>
      <section class="d-flex flex-column mt-3">
        <span class="group-label">{{ $t('selectPartsPage.groupLabel') }}</span>
        <treeselect
          v-model="selectedPartGroup"
          :multiple="false"
          :open-on-click="true"
          :options="partGroupOptions"
          :placeholder="null"
          :showCount="true"
        ></treeselect>
      </section>
      <div class="scroll-area mt-3 mb-4">
        <PartTable 
          :headers="['Part name']" 
          :parts="filtered"
          :selectedPartsIds="selectedPartsIds"
          :displayItems="displayItems" 
          checkable
          @rowClick="itemClicked"
          @onSelectAllParts="allItemsClicked"
        ></PartTable>
      </div>
      <v-btn
        class="mt-3"
        color="#033e8c"
        height="45px"
        block
        depressed
        dark
        @click="complete"
        :disabled=disableCompleteButton
      >
        {{ completeBtnTitle }}
      </v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import LabelTextField from "@/components/common/LabelTextField.vue"
import PartTable from "@/components/common/PartTable.vue";

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import { getTreeItems } from "@/helpers"

export default {
  name: "SelectPartsPage",
  components: {
    AppBar,
    PartTable,
    LabelTextField,
    Treeselect
  },
  data () {
    return {
      //title: '',
      carId: null,
      parentId: null,
      partGroups: [],
      selectedPartGroup: null,
      partGroupOptions: null,
      parts: [],
      filtered: [],
      displayItems: ['part_name'],
      selectedPartsIds: []
    }
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName

    const pid = this.$store.getters.getCurrentPID
    this.$store.dispatch('retrieveProcessVariables', pid)
    .then(response => {
      try {
        this.carId = response.data.data.car_id.value
        /* td 20200905 #111 fixed the parse error when receiving a string from the server */
        this.parentId = JSON.parse(response.data.data.part_group_id.value)

        let url = '/Parts/get?'
        this.parentId.forEach(id => {
          url += 'part_group_id[]=' + id + '&'
        })

        if (this.carId) {
          url += 'car_id=' + this.carId
        }

        if (url.endsWith('&')) {
          url = url.slice(0, url.length - 1)
        }

        this.fetchParts(url)
        /* td 2020090662338 #113 part groups fix */
        this.fetchPartGroups(this.carId, this.parentId)
      } catch (error) {
        console.log("Failed retrieving variables from API.", error)
      }
    })
    .catch(error => {
      console.log("Failed retrieving variables from API", error)
    })
    // this.title = "Select Parts"
    // const url = '/Parts/get?part_group_id[]=4&part_group_id[]=10&part_group_id[]=5&car_id=4'
    // this.fetchParts(url)
    // this.fetchPartGroups(4)
  },
  computed: {
    disableCompleteButton()
    {
      if (this.selectedPartsIds.length == 0)
        return true
      else
        return false
    },
    completeBtnTitle()
    {
      return this.$store.getters.getCurrentTask.taskName + " (" +this.selectedPartsIds.length + ")"
    }
  },
  methods: {
    filter(value) {
      const filter = value.toLowerCase()
      this.filtered = this.parts.filter(part => {
        if (
          part.oem_number?.toLowerCase().includes(filter) 
          /* || part.serial_number?.toLowerCase().includes(filter) */
          || part.part_name?.toLowerCase().includes(filter)
          || part.description?.toLowerCase().includes(filter)) {
          return true
        }
        
        return false
      })
    },
    fetchParts(url) {
      console.log(url);
      this.axios.get(url, {}, { withCredentials: true })
      .then(response => {
        console.log(response);
        //this.parts = response.data.data.reduce((accum, cur) => [...accum, ...cur.parts], [])
        this.parts = response.data.data;
        
        this.filtered = this.parts.map(e => {
          e["checked"] = false 
          return e
        })
  
      })
      .catch(error => {
        console.log("Failed retrieving parts", error)
      })
    },
    fetchPartGroups(id, part_group_id=null) {
      let part_group_url_suffix = '';
      /* td 2020090662338 #113 part groups fix */
      if (part_group_id !=null)
      {
        part_group_id.forEach(id => {
          part_group_url_suffix += 'part_group_id[]=' + id + '&'
        })
      }
      const url = `/PartGroupsTemplate/get?car_id=${id}&${part_group_url_suffix}`
      console.log(url);
      this.axios.get(url, {}, { withCredentials: true })
      .then(response => {
        this.partGroups = response.data.data
        this.partGroupOptions = getTreeItems(this.partGroups)
        /**
         * default value for part groups, now excluded
         */
        // this.selectedPartGroup = this.partGroupOptions[0].id
      })
      .catch(error => {
        console.log("Failed retrieving part groups.", error)
      })
    },
    itemClicked(partId) {
      /* td 202009051853 #113 we need to use part_id, not the index */
      /* we also use the this.selectedPartIds as the single source of truth */
      //console.log('itemClicked: ', partId)
      if (!this.selectedPartsIds.includes(partId))
      {
        this.selectedPartsIds.push(partId)
      } else {
        this.selectedPartsIds = this.selectedPartsIds.filter( id => id != partId )
      }
      //this.filtered[index].checked = !this.filtered[index].checked
      //console.log("Item value changed %s, %s", this.filtered[index].name, this.filtered[index].checked)
    },
    allItemsClicked() {
      // we set selected for all filtered parts (if filtered is empty, we take the parts list instead)
      console.log('all items clicked');
      // we iterate through this.filtered and we itemClicked(filtered.part_id) each one
      this.filtered.forEach(item => {
        this.itemClicked(item.part_id);
      })
    },
    complete() {
      /* td 202009070100 #113 we need to use part_id globally, not on the filtered results */
      const variables = {
        "variables": {
          "parts": {
            "value": JSON.stringify(this.selectedPartsIds),
            "type": "String"
          }
        }
      }
      
      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    }
  },
  watch: {
    selectedPartGroup: function (value) {
      let url=''
      
      if (value === undefined) {
        this.parts = []
        this.filtered = []
        /* td 20200900003 #113 we fetch parts for all part groups when no selection is made */
        url = '/PartsTemplate/get?'
        this.parentId.forEach(id => {
          url += 'part_group_id[]=' + id + '&'
        })

        this.fetchParts(url)

        return
      }
      
      url = `/PartsTemplate/get/${value}`
      this.fetchParts(url)
    }
  },
}
</script>

<style scoped>
.group-label {
  font-size: 0.75rem;
  font-weight: bold;
  color: #b0bac9;
  text-align: left;
}

.scroll-area {
  height: 450px;
  overflow: auto;
}
</style>